import { render, staticRenderFns } from "./course.vue?vue&type=template&id=066e41b5&scoped=true"
import script from "./course.vue?vue&type=script&lang=ts"
export * from "./course.vue?vue&type=script&lang=ts"
import style0 from "./course.vue?vue&type=style&index=0&id=066e41b5&prod&lang=less"
import style1 from "./course.vue?vue&type=style&index=1&id=066e41b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e41b5",
  null
  
)

export default component.exports